define('model/TimeSlotModel',['require','backbone'],function (require) {
	
	var Backbone = require('backbone');
	
	/**
	 * Time slot info model
	 * 
	 * @class TimeSlotModel
	 */
	return Backbone.Model.extend({
		
		defaults: {
			id: '',
			time: '',
			date: '',
			type: 'free',
			state: ''
		},

		toJSON: function (options) {
			var result = Backbone.Model.prototype.toJSON.apply(this, [options]);
			result.datetime = Date.parseMysqlDate(this.get('id'));

			return result;
		}
	
	});
	
});
